import { useLanguage } from '../../../contexts/LanguageContext';
import translations from '../../../i18n/translations';

export default function Footer() {
  const { language } = useLanguage();
  const t = translations[language].footer;

  return (
    <footer className="relative bg-[#0F1419] text-white overflow-hidden">
      {/* World Map Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Top Border */}
      <div className="h-0.5 bg-gradient-to-r from-transparent via-[#00A3FF] to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://static.readdy.ai/image/48dde99e8fd8a26df059daa5a847ba45/92677d645ff7770f827851cf36daa564.png"
                alt="Logo"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-gray-400 mb-6 leading-relaxed">
              {t.description}
            </p>

            <div className="text-white font-serif text-2xl leading-tight">
              {t.tagline}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base font-bold mb-4">{t.services.title}</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-sm text-gray-400 hover:text-[#00A3FF] transition-colors cursor-pointer">
                  {t.services.cabling}
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-400 hover:text-[#00A3FF] transition-colors cursor-pointer">
                  {t.services.infrastructure}
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-400 hover:text-[#00A3FF] transition-colors cursor-pointer">
                  {t.services.managed}
                </a>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-base font-bold mb-4">{t.solutions.title}</h4>
            <ul className="space-y-3">
              <li>
                <a href="#contact" className="text-sm text-gray-400 hover:text-[#00A3FF] transition-colors cursor-pointer">
                  {t.solutions.datacenter}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-gray-400 hover:text-[#00A3FF] transition-colors cursor-pointer">
                  {t.solutions.security}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-gray-400 hover:text-[#00A3FF] transition-colors cursor-pointer">
                  {t.solutions.cloud}
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-base font-bold mb-4">{t.company.title}</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-sm text-gray-400 hover:text-[#00A3FF] transition-colors cursor-pointer">
                  {t.company.about}
                </a>
              </li>
              <li>
                <a href="#why-us" className="text-sm text-gray-400 hover:text-[#00A3FF] transition-colors cursor-pointer">
                  {t.company.cases}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-gray-400 hover:text-[#00A3FF] transition-colors cursor-pointer">
                  {t.company.contact}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-[#2D3748] mb-8"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          {/* Copyright */}
          <div className="text-xs text-gray-500">
            {t.copyright}
          </div>
        </div>
      </div>
    </footer>
  );
}